// -----------------------------------------------------------
// FloraIQ - PointCloudAssetDrawer — Drawer Detalhe do Ativo 3D
// -----------------------------------------------------------

import { pointCloudAssets } from "@/mocks/pointcloud";
import ProcessingBadge, { QualityBadge } from "./PointCloudStatusBadge";

interface PointCloudAssetDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PointCloudAssetDrawer({ isOpen, onClose }: PointCloudAssetDrawerProps) {
  if (!isOpen) return null;

  const asset = pointCloudAssets[0];

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-lg bg-white h-full overflow-y-auto slide-in-from-right">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-background-200/70 px-5 py-4 flex items-center justify-between z-10">
          <div>
            <h3 className="text-base font-bold text-foreground-900 font-heading">{asset.nome}</h3>
            <p className="text-xs text-foreground-500 mt-0.5">Detalhe do Ativo 3D</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer" aria-label="Fechar">
            <i className="ri-close-line text-foreground-600"></i>
          </button>
        </div>

        <div className="p-5 space-y-5">
          {/* Info grid */}
          <div className="grid grid-cols-2 gap-4">
            {[
              { l: "Tipo", v: asset.tipo },
              { l: "Projeto", v: asset.projeto },
              { l: "Área coberta", v: `${asset.areaHa} ha` },
              { l: "Data", v: new Date(asset.data + "T00:00:00").toLocaleDateString("pt-BR") },
              { l: "Equipamento", v: asset.equipamento },
              { l: "Formato", v: asset.formato },
              { l: "Tamanho", v: `${asset.tamanhoMb.toLocaleString("pt-BR")} MB` },
              { l: "SRID", v: asset.srid },
              { l: "Pontos", v: asset.pontos },
              { l: "Árvores vinculadas", v: asset.arvoresVinculadas.toLocaleString("pt-BR") },
            ].map((row) => (
              <div key={row.l}>
                <span className="text-[10px] text-foreground-400 uppercase tracking-wide">{row.l}</span>
                <p className="text-xs text-foreground-700 mt-0.5">{row.v}</p>
              </div>
            ))}
            <div>
              <span className="text-[10px] text-foreground-400 uppercase tracking-wide">Status</span>
              <div className="mt-0.5"><ProcessingBadge status={asset.status} /></div>
            </div>
            <div>
              <span className="text-[10px] text-foreground-400 uppercase tracking-wide">Qualidade</span>
              <div className="mt-0.5"><QualityBadge value={asset.qualidade} /></div>
            </div>
          </div>

          {/* Histórico de processamento */}
          <div className="border-t border-background-200/50 pt-4">
            <h4 className="text-xs font-bold text-foreground-900 font-heading uppercase tracking-wide mb-2">Histórico de Processamento</h4>
            <div className="space-y-2">
              {[
                { date: "2024-08-15", event: "Coleta LiDAR concluída", status: "completo" },
                { date: "2024-08-18", event: "Processamento inicial (PDAL)", status: "completo" },
                { date: "2024-08-22", event: "Classificação automática (CSF+SMRF)", status: "completo" },
                { date: "2024-08-25", event: "Extração de métricas arbóreas", status: "completo" },
                { date: "2024-08-28", event: "Validação e vinculação CTA", status: "completo" },
              ].map((h, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-green-500 mt-1.5 shrink-0"></div>
                  <div>
                    <p className="text-xs text-foreground-700">{h.event}</p>
                    <p className="text-[10px] text-foreground-400">{new Date(h.date + "T00:00:00").toLocaleDateString("pt-BR")}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Inconsistências */}
          <div className="border-t border-background-200/50 pt-4">
            <h4 className="text-xs font-bold text-foreground-900 font-heading uppercase tracking-wide mb-2">Inconsistências</h4>
            <p className="text-xs text-green-600 flex items-center gap-1">
              <i className="ri-check-line"></i> Nenhuma inconsistência detectada
            </p>
          </div>
        </div>

        {/* Footer actions */}
        <div className="sticky bottom-0 bg-white border-t border-background-200/70 px-5 py-3 flex items-center gap-2 flex-wrap">
          <button className="btn-primary text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
            <i className="ri-stack-line mr-1"></i>Abrir 3D
          </button>
          <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
            <i className="ri-refresh-line mr-1"></i>Reprocessar
          </button>
          <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
            <i className="ri-map-pin-line mr-1"></i>Ver Mapa
          </button>
          <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
            <i className="ri-file-chart-line mr-1"></i>Gerar Relatório
          </button>
        </div>
      </div>
    </div>
  );
}